export default __webpack_public_path__ + "static/media/86.89d28a08.png";